import * as React from 'react'
import type { SVGProps } from 'react'
function SvgArbeitslosigkeitLangzeitquote216135437157(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 276.4 253.8"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M158.6,0C99.9,0,49.7,43.8,41.9,101.9c-0.1,0.9,0.1,1.8,0.7,2.6c0.6,0.7,1.4,1.2,2.3,1.3c0.9,0.1,1.8-0.1,2.6-0.7 c0.7-0.6,1.2-1.4,1.3-2.3C56.2,48.2,103.4,7,158.6,7c29.4,0,57.2,11.7,78.3,32.9c20.9,21.1,32.5,48.8,32.5,77.9 c0,60-48.7,109.6-108.7,110.8c-1.9,0-3.5,1.6-3.4,3.6c0,1.9,1.6,3.4,3.5,3.4l0.5,0v0c30.8-0.7,59.7-13.2,81.3-35.2 c21.8-22.2,33.8-51.5,33.8-82.6C276.4,52.8,223.5,0,158.6,0z" />
        <path d="M66.5,98.9l0.5,0v0c1.4-0.2,2.6-1.2,2.9-2.6c9.9-41,46.4-69.6,88.6-69.6c18.1,0,35.6,5.3,50.5,15.3 c0.8,0.5,1.7,0.7,2.6,0.5c0.9-0.2,1.7-0.7,2.2-1.5c0.5-0.8,0.7-1.7,0.5-2.6s-0.7-1.7-1.5-2.2c-16.1-10.8-34.9-16.4-54.4-16.4 c-45.5,0-84.7,30.8-95.4,75c-0.5,1.9,0.7,3.8,2.6,4.2C66,98.9,66.3,98.9,66.5,98.9z" />
        <path d="M158.6,216c54.1,0,98.2-44.1,98.2-98.2c0-1.9-1.6-3.5-3.5-3.5s-3.5,1.6-3.5,3.5c0,50.3-40.9,91.2-91.2,91.2 c-2.3,0-4.5-0.1-6.7-0.2c-2-0.1-3.6,1.3-3.8,3.2c-0.1,0.9,0.2,1.8,0.8,2.5c0.6,0.7,1.5,1.1,2.4,1.2 C153.7,215.9,156.2,216,158.6,216L158.6,216z" />
        <path d="M167,131.2l28.1,28.1c0.7,0.7,1.5,1,2.5,1c0.9,0,1.8-0.4,2.5-1c1.4-1.4,1.4-3.6,0-4.9l-27.9-27.9c1.6-2.5,2.6-5.4,2.6-8.5 c0-7.4-5.1-13.5-12-15.1v-45c0-1.9-1.6-3.5-3.5-3.5s-3.5,1.6-3.5,3.5v45c-6.9,1.6-12,7.8-12,15.1c0,8.6,7,15.5,15.5,15.5 C162,133.3,164.7,132.5,167,131.2z M167.6,117.8c0,4.7-3.8,8.5-8.5,8.5s-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5S167.6,113.1,167.6,117.8z " />
        <path d="M72.3,199.9C25,199.9,0,217.3,0,250.3c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5c0-28.8,22-43.4,65.3-43.4 c43.3,0,65.3,14.6,65.3,43.4c0,1.9,1.6,3.5,3.5,3.5h0c1.9,0,3.5-1.6,3.5-3.5C144.6,217.3,119.6,199.9,72.3,199.9z" />
        <path d="M36.7,149.2c0,19.6,16,35.6,35.6,35.6s35.6-16,35.6-35.6s-16-35.6-35.6-35.6S36.7,129.6,36.7,149.2z M43.7,149.2 c0-15.8,12.8-28.6,28.6-28.6s28.6,12.8,28.6,28.6c0,15.8-12.8,28.6-28.6,28.6S43.7,165,43.7,149.2z" />
      </g>
    </svg>
  )
}
export default SvgArbeitslosigkeitLangzeitquote216135437157
